import Vue from 'vue'
import VueMoment from 'vue-moment'
import App from '@/App'
import axios from 'axios'
import Alert from '@/plugins/alert'
import EventBus from '@/plugins/eventBus'
import router from '@/router'
import store from '@/store'
import Vuelidate from 'vuelidate'
import { UNAUTHORIZED_RESPONSE_INTERCEPTOR, REQUEST_TOKEN_INTERCEPTOR } from '@/interceptors'

Vue.use(Alert)
Vue.use(EventBus)
Vue.use(Vuelidate)
Vue.use(VueMoment)

Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.config.devtools = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  beforeCreate () {
    // add interceptors
    axios.interceptors.request.use(...REQUEST_TOKEN_INTERCEPTOR)
    axios.interceptors.response.use(...UNAUTHORIZED_RESPONSE_INTERCEPTOR)

    this.$store.dispatch('account/init')
  }
})



// WEBPACK FOOTER //
// ./src/main.js